<template>
  <div id="new-customer-modal"
       class="modal fade"
       tabindex="-1"
       role="dialog"
       aria-labelledby="new-customer-modal-label"
       aria-hidden="true">
    <form id="new-customer-form" class="modal-dialog custom-modal">
      <div class="modal-content">
        <div class="modal-header custom-modal-header px-i">
          <div class="custom-modal-header-start">
            <h4 class="modal-title custom-modal-header-start-title">
              New Customer
            </h4>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body custom-modal-body px-i">
          <RadioControlWrapper
            label="Customer Type">
            <BoolRadioControl
              v-model="customerData.account_type"
              name="customer[account_type]"
              label="Individual"
              default-checked
              used-value="Individual" />
            <BoolRadioControl
              v-model="customerData.account_type"
              name="customer[account_type]"
              label="Business"
              used-value="Business" />
          </RadioControlWrapper>
          <CardDivider />
          <div class="form-card-group form-card-group-nowrap">
            <div class="form-card-group-item form-card-group-item-small">
              <ItemSelect
                v-model="customerData.salutation"
                :items="salutationOptions"
                name="customer[salutation]"
                key-method="name"
                value-method="name"
                label="Salutation"
                :object-method="false" />
            </div>
            <div class="form-card-group-item form-card-group-item-medium">
              <TextInput
                v-model="customerData.first_name"
                name="customer[first_name]"
                custom-label="First name"
                width="medium" />
            </div>
            <div class="form-card-group-item form-card-group-item-medium">
              <TextInput
                v-model="customerData.last_name"
                name="customer[last_name]"
                custom-label="Last name"
                width="medium" />
            </div>
          </div>
          <TextInput
            v-model="customerData.company_name"
            name="customer[company_name]"
            custom-label="Company name"
            width="medium" />
          <TextInput
            v-model="displayName"
            name="customer[display_name]"
            disclaimer="This is the name that will be shown on invoices, expenses created for this customer."
            width="medium"
            custom-label="Display name"
            required />
          <CardDivider />
          <TextInput
            v-model="customerData.email"
            name="customer[email]"
            custom-label="Email"
            width="medium" />
          <div class="form-card-group">
            <div class="form-card-group-item col-24 col-md-12">
              <label for="mobileInput" class="custom-form-group-label">Mobile Number</label>
              <vue-tel-input
                ref="mobileInput"
                v-model="customerData.mobile_number"
                input-id="mobileInput"
                name="customer[mobile_number]"
                :ignored-countries="['IL']"
                :enabled-country-code="true"
                :preferred-countries="['LB', 'SA']"
                :valid-characters-only="true"
                :default-country="'LB'"
                :disabled-fetching-country="true"
                wrapper-classes="ihjoz-tel-input"
                input-classes="ihjoz-tel-input-field ihjoz-tel-input-field-code-visible"
                @onInput="onInputMobileNumber"
                @input="validateMobileNumber" />
              <input
                :value="selectedPhoneCountryCode"
                name="mobile_country_code"
                type="hidden">
            </div>
            <div class="form-card-group-item col-24 col-md-12">
              <label for="workInput" class="custom-form-group-label">Work Number</label>
              <vue-tel-input
                ref="workInput"
                v-model="customerData.work_number"
                input-id="workInput"
                name="customer[work_number]"
                :ignored-countries="['IL']"
                :enabled-country-code="true"
                :enabled-country-codes="['LB', 'SA']"
                :valid-characters-only="true"
                :default-country="'LB'"
                :disabled-fetching-country="true"
                wrapper-classes="ihjoz-tel-input"
                input-classes="ihjoz-tel-input-field ihjoz-tel-input-field-code-visible"
                @onInput="onInputWorkNumber"
                @input="validateWorkNumber" />
              <input
                :value="selectedWorkCountryCode"
                name="work_country_code"
                type="hidden">
            </div>
          </div>
          <CardDivider />
          <div class="form-card-group">
            <div class="form-card-group-item form-card-group-item-vertical col-24 col-md-12">
              <div class="form-card-group-item-title">
                <h3 class="form-card-group-item-title-text">
                  Billing Address
                </h3>
              </div>
              <MultilineTextInput
                v-model="customerBillingAddress.address"
                name="customer[billing_address][address]"
                custom-label="Address" />
              <ItemSelect
                v-model="customerBillingAddress.country"
                :items="publicCountries"
                name="customer[billing_address][country]"
                label="Country"
                value-method="name"
                :shortened="false" />
              <TextInput
                v-model="customerBillingAddress.city"
                name="customer[billing_address][city]"
                custom-label="City" />
              <TextInput
                v-model="customerBillingAddress.zip_code"
                name="customer[billing_address][zip_code]"
                custom-label="Zip Code" />
              <TextInput
                v-model="customerBillingAddress.attention"
                name="customer[billing_address][attention]"
                custom-label="Attention" />
              <div class="form-group custom-form-group">
                <label for="billingMobileInput" class="custom-form-group-label">Phone Number</label>
                <vue-tel-input
                  ref="billingMobileInput"
                  v-model="customerBillingAddress.phone_number"
                  input-id="billingMobileInput"
                  name="customer[billing_address][phone_number]"
                  :ignored-countries="['IL']"
                  :enabled-country-code="true"
                  :preferred-countries="['LB', 'SA']"
                  :valid-characters-only="true"
                  :default-country="'LB'"
                  :disabled-fetching-country="true"
                  wrapper-classes="ihjoz-tel-input"
                  input-classes="ihjoz-tel-input-field ihjoz-tel-input-field-code-visible"
                  @onInput="onInputBillingNumber"
                  @input="validateBillingMobileNumber" />
                <input
                  :value="selectedBillingCountryCode"
                  name="customer[billing_address][billing_country_code]"
                  type="hidden">
              </div>
            </div>

            <div class="form-card-group-item form-card-group-item-vertical col-24 col-md-12">
              <div class="form-card-group-item-title">
                <h3 class="form-card-group-item-title-text">
                  Shipping Address
                </h3>
                <a id="same-as-billing" href="#" class="form-card-group-item-title-action" @click="autoFillShippingAddress($event)">
                  Same as billing
                </a>
              </div>
              <MultilineTextInput
                v-model="customerShippingAddress.address"
                name="customer[shipping_address][address]"
                custom-label="Address" />
              <ItemSelect
                v-model="customerShippingAddress.country"
                :items="publicCountries"
                name="customer[shipping_address][country]"
                label="Country"
                value-method="name"
                :shortened="false" />
              <TextInput
                v-model="customerShippingAddress.city"
                name="customer[shipping_address][city]"
                custom-label="City" />
              <TextInput
                v-model="customerShippingAddress.zip_code"
                name="customer[shipping_address][zip_code]"
                custom-label="Zip Code" />
              <TextInput
                v-model="customerShippingAddress.attention"
                name="customer[shipping_address][attention]"
                custom-label="Attention" />
              <div class="form-group custom-form-group">
                <label for="shippingMobileInput" class="custom-form-group-label">Phone Number</label>
                <vue-tel-input
                  ref="shippingMobileInput"
                  v-model="customerShippingAddress.phone_number"
                  input-id="shippingMobileInput"
                  name="customer[shipping_address][phone_number]"
                  :ignored-countries="['IL']"
                  :enabled-country-code="true"
                  :preferred-countries="['LB', 'SA']"
                  :valid-characters-only="true"
                  :default-country="'LB'"
                  :disabled-fetching-country="true"
                  wrapper-classes="ihjoz-tel-input"
                  input-classes="ihjoz-tel-input-field ihjoz-tel-input-field-code-visible"
                  @onInput="onInputShippingNumber"
                  @input="validateShippingMobileNumber" />
                <input
                  :value="selectedShippingCountryCode"
                  :name="`customer[shipping_address][shipping_country_code]`"
                  type="hidden">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer custom-modal-footer px-i">
          <button type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  class="btn btn-outline-primary ihjoz-button"
                  @click="clearCustomerData">
            Cancel
          </button>
          <button type="button"
                  class="btn btn-primary ihjoz-button"
                  @click="createFormSubmitted($event)">
            Save
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ItemSelect from "../../../shared/components/UI/ItemSelect.vue";
import TextInput from "../../../shared/components/UI/TextInput.vue";
import MultilineTextInput from "../../../shared/components/UI/MultilineTextInput.vue";
import RadioControlWrapper from "../../../shared/components/UI/RadioControlWrapper.vue";
import BoolRadioControl from "../../../shared/components/UI/BoolRadioControl.vue";
import CardDivider from "../../../shared/components/UI/CardDivider.vue";
import { VueTelInput } from "vue-tel-input";
import CustomerFormMixin from "./CustomerFormMixin";
import ComponentMixin from "../../../shared/Mixins/ComponentMixin";
import store from "./CustomerStore";

export default {
  name: "CustomerForm",

  components: {
    ItemSelect,
    TextInput,
    MultilineTextInput,
    RadioControlWrapper,
    BoolRadioControl,
    VueTelInput,
    CardDivider
  },

  mixins: [CustomerFormMixin, ComponentMixin],

  data () {
    return {
      customerData: {
        shipping_address: {},
        billing_address: {}
      }
    };
  },

  methods: {
    clearCustomerData () {
      this.customerData = { shipping_address: {}, billing_address: {} };
    },

    async createFormSubmitted (e) {
      e.preventDefault();
      let response = this.handleResponseInplace(await store.createModal());

      if (response.success) {
        $("#new-customer-modal").modal("hide");
        this.$emit("newCustomer", response.resource);
        this.clearCustomerData();
      }
    }
  }
};
</script>
